import { List, useStyles } from '@archipro-design/aria';
import * as S from './MobileBottomMenuContent.style';
import {
    CheckLine,
    CloseLine,
    EyeLine,
    InboxCustom,
    PencilLine,
} from '@archipro-design/icons';
import { useDesignBoardPageState } from '~/modules/design-board/component/context';
import { MobileMenuAvatar } from '~/modules/design-board/component/mobile-menu/MobileMenuAvatar';
import { SHOW_COMMENT } from '../../config';

export const MobilePermissionMenu = () => {
    const {
        dispatch,
        state: { bottomMenuData },
    } = useDesignBoardPageState();

    const { css } = useStyles({
        isEditPermission: Boolean(bottomMenuData?.name),
    });

    const closeBottomMenu = () => {
        dispatch({ type: 'CloseDrawer' });
    };

    const onClickCanEdit = () => {
        bottomMenuData?.changePermission?.('edit');
        closeBottomMenu();
    };

    const onClickCanView = () => {
        bottomMenuData?.changePermission?.('view');
        closeBottomMenu();
    };

    const onClickCanComment = () => {
        bottomMenuData?.changePermission?.('comment');
        closeBottomMenu();
    };

    const onClickRemove = () => {
        bottomMenuData?.changePermission?.(null);
        closeBottomMenu();
    };

    const menuItems = [
        {
            label: 'Can edit',
            onClick: onClickCanEdit,
            iconBefore: (
                <PencilLine
                    className={getCheckClassName(
                        'edit-icon',
                        bottomMenuData?.canEdit
                    )}
                />
            ),
            iconAfter: getCheckIcon(bottomMenuData?.canEdit),
            className: bottomMenuData?.canEdit ? 'checked' : 'unchecked',
        },
        SHOW_COMMENT && {
            label: 'Can comment',
            onClick: onClickCanComment,
            iconBefore: (
                <InboxCustom
                    className={getCheckClassName(
                        'comment-icon',
                        bottomMenuData?.canComment
                    )}
                />
            ),
            iconAfter: getCheckIcon(bottomMenuData?.canComment),
            className: bottomMenuData?.canComment ? 'checked' : 'unchecked',
        },
        {
            label: 'Can view',
            onClick: onClickCanView,
            iconBefore: (
                <EyeLine
                    className={getCheckClassName(
                        'view-icon',
                        bottomMenuData?.canView
                    )}
                />
            ),
            iconAfter: getCheckIcon(bottomMenuData?.canView),
            className: bottomMenuData?.canView ? 'checked' : 'unchecked',
        },
        bottomMenuData?.canRemove && {
            label: 'Remove',
            onClick: onClickRemove,
            iconBefore: <CloseLine className="close-icon" />,
            className: css(S.RemoveRow),
        },
    ];

    return (
        <div className={css(S.BottomMenuWrapper)}>
            {bottomMenuData?.name && (
                <MobileMenuAvatar
                    name={bottomMenuData?.name}
                    email={bottomMenuData?.email}
                    imageUrl={bottomMenuData?.profileImageUrl}
                />
            )}
            <List items={menuItems} />
        </div>
    );
};

const getCheckIcon = (checked?: boolean) => {
    return checked ? <CheckLine className="check-icon" /> : undefined;
};

const getCheckClassName = (className: string, checked?: boolean) => {
    return className + (checked ? ' checked' : ' unchecked');
};
